import { styled } from '../../Styles/stitches.config'
import { Player } from '@lottiefiles/react-lottie-player'

export const StyledLoading = styled(Player, {})
